import {Component, Input, OnInit} from '@angular/core';
import {FiltersService} from "../../../filters/filters.service";
import {Filter} from "../../../filters/filter-block/filter-item/filter";
import {AppConfigService} from "../../../../../config/app-config.service";
import {TranslateService} from "../../../../../shared/translate.service";

@Component({
  selector: 'app-choosen-filter',
  templateUrl: './choosen-filter.component.html',
  styleUrls: ['./choosen-filter.component.css']
})
export class ChoosenFilterComponent implements OnInit {

  @Input() field: string;

  @Input() filters: Filter[];

  normal: Filter[] = [];

  or: Filter[] = [];

  excluded: Filter[] = [];

  showMore: boolean = false;

  maxWordsInTag: number;

  constructor(private filtersService: FiltersService,
              private translator: TranslateService,
              private appConfig: AppConfigService) {
  }

  preventDef(event) {
    if (event) {
      event.preventDefault();
    }
  }

  ngOnInit() {
    this.filters.forEach(filter => {
      if (filter.excluded) {
        this.excluded.push(filter);
      } else if (filter.or) {
        this.or.push(filter);
      } else {
        this.normal.push(filter);
      }
    });
    this.filters.sort((a, b) => {
      if (this.isAnd(a) && this.isAnd(b)) {
        return 0;
      } else if (this.isAnd(a) && !this.isAnd(b)) {
        return -1;
      } else if (this.isAnd(b) && !this.isAnd(a)) {
        return 1;
      } else if (this.isOr(a) && this.isOr(b)) {
        return 0;
      } else if (this.isOr(a) && !this.isOr(b)) {
        return -1;
      } else if (this.isOr(b) && !this.isOr(a) ) {
        return 1;
      } else {
        return 0;
      }
    });
    this.maxWordsInTag = this.appConfig.facetTagMax;
  }

  private isAnd(a) {
    return !a.or && !a.excluded;
  }

  private isOr(a) {
    return a.or;
  }

  private isExcluded(a) {
    return a.excluded;
  }

  tryTranslate(key: string): string {
    let result = this.filtersService.translateByFieldName(key);
    if (result != key) {
      return result;
    } else {
      return this.translator.translate(key);
    }
  }

  removeFilterGroup() {
    this.filtersService.cleanGroup(this.field);
    this.filtersService.navigateByFilters(true, true, true);
  }

  itemLabel() {
    return this.translator
      .translate('ChoosenFilter.remove')+' '+this.tryTranslate(this.field);
  }

}
